import { Link } from 'react-router-dom';
import CrowLogo from '../brand/CrowLogo';

export default function AuthLayout({ children, title, subtitle }) {
  return (
    <div className="min-h-screen bg-surface-page flex flex-col items-center justify-center p-4">
      {/* Logo */}
      <div className="mb-8 text-center">
        <h1 className="flex justify-center"><CrowLogo variant="stacked" height={96} /></h1>
        <p className="text-small text-ink-muted mt-1">Automotive maintenance, simplified</p>
      </div>

      {/* Card */}
      <div className="w-full max-w-md bg-surface-card rounded-card border border-border-default shadow-elevation-1 p-6 lg:p-8">
        {title && (
          <div className="mb-6">
            <h2 className="text-section-title text-ink">{title}</h2>
            {subtitle && <p className="text-body text-ink-muted mt-1">{subtitle}</p>}
          </div>
        )}
        {children}
      </div>

      {/* Footer links */}
      <div className="mt-6 flex gap-4 text-small text-ink-muted">
        <Link to="/terms" className="hover:text-accent transition-colors">Terms</Link>
        <Link to="/privacy" className="hover:text-accent transition-colors">Privacy</Link>
        <a href="mailto:support@crowmobile.com" className="hover:text-accent transition-colors">Support</a>
      </div>
    </div>
  );
}
